export const fileExtension = ({
  filename,
}: {
  filename: string;
}): string | undefined => {
  return filename.split(".").pop();
};
